<template>
  <main id="main">
    <header class="bg_gradient_theme_to_right p-4 rounded_header top-0 d-flex flex-column row-gap-5">
        <div class="w-100 d-flex justify-content-between align-items-center">
            <div>
                <img id="arrow_back_page" src="@/assets/imgs/back.svg" alt="" @click="$router.go(-1)">
                <span id="title_header_page" class="bold">{{ t('my_profile') }}</span>
            </div>
            <img src="@/assets/imgs/share.svg" class="share-btn" @click="shareContent('profile', `${teacher.name} ${teacher.family}`)">
        </div>
        
        <div class="w-100 d-flex justify-content-between align-items-center">
            <div style="width: calc(100% - 14rem)">
                <p class="font_larger bold text-white">{{ teacher.name }} {{ teacher.family }}</p>
                <div class="d-flex align-items-start mt-2">
                    <span class="bold text-white font_small" style="white-space: pre-wrap;">{{ teacher.bio || t('no_bio') }}</span>
                    <img src="@/assets/imgs/edit-blue-border.svg" class="edit-bio-btn drop_shadow cursor-pointer ms-2" alt="" @click="openBioModal">
                </div>
            </div>
            
            <div class="position-relative">
                <swiper
                    :modules="modules"
                    :pagination="{ clickable: true }"
                    :loop="galleryImages.length > 1"
                    class="profile-slider rounded-5 shadow"
                >
                    <swiper-slide v-for="(img, index) in galleryImages" :key="index">
                        <img :src="img" class="profile-image" alt="Teacher profile">
                    </swiper-slide>
                </swiper>
                
                <div class="edit-profile-icon" @click="triggerProfilePicUpload">
                    <div v-if="isUploadingProfile" class="spinner-border text-primary spinner-sm" role="status"></div>
                </div>
                <input type="file" ref="profilePicInput" @change="handleProfilePicSelect" accept="image/*" style="display: none">
            </div>
        </div>

        <div class="d-flex justify-content-start column-gap-3">
            <div class="bg-white rounded-5 d-flex flex-column align-items-center justify-content-center p-3 shadow cursor-pointer" style="width: 8rem" @click="$router.push({ name: 'TeacherFollowersList' })">
                <img src="@/assets/imgs/user-_2_.svg" class="icon-size-3 drop_shadow">
                <span class="font_small bold mt-2">{{ teacher.followers || 0 }}</span>
                <span class="font_small bold">{{ t('followers') }}</span>
            </div>
            <div class="bg-white rounded-5 d-flex flex-column align-items-center justify-content-center p-3 shadow" style="width: 8rem">
                <img src="@/assets/imgs/share-post.svg" class="icon-size-3 drop_shadow">
                <span class="font_small bold mt-2">{{ teacher.post_count || 0 }}</span>
                <span class="font_small bold">{{ t('posts') }}</span>
            </div>
        </div>
    </header>

    <div v-if="loading" class="text-center p-5">
        <p>{{ t('loading') }}</p>
    </div>

    <div v-else class="p-4 pb-6 w-100">

        <div class="w-100 d-flex flex-wrap justify-content-start gap-2">
            
            <article class="bg-white rounded-5 shadow p-2 item-post cursor-pointer" @click="$router.push({ name: 'TeacherAddPost' })">
                <div class="rounded-5 position-relative d-flex justify-content-center align-items-center bg_gray_light" style="height: 11rem; border: 2px dashed #ccc;">
                    <span class="font_large bold text_color_gray">+</span>
                    <span class="font_small text-white bold bg-info p-2 rounded-pill position-absolute bottom-2 start-2">{{ t('add_post') }}</span>
                </div>
            </article>

            <article 
                v-for="post in teacher.teacher_posts" 
                :key="post.id" 
                class="bg-white rounded-5 shadow p-2 item-post cursor-pointer position-relative"
                @click="goToPostDetail(post.id)"
            >
                <div class="rounded-5 overflow-hidden position-relative" style="height: 11rem;">
                    <img :src="post.pic" class="w-100 h-100 object-fit-cover" alt="" @error="$event.target.src = require('@/assets/imgs/NoPath - Copy (5).png')">
                    
                    <div class="position-absolute bottom-0 w-100 d-flex justify-content-center pb-2">
                         <button class="btn-manage-post" @click.stop="openPostSettings(post)">مدیریت پست</button>
                    </div>
                </div>
                <h3 class="font_small bold mt-2 text-center text-truncate px-1">{{ post.caption }}</h3>
            </article>

        </div>
    </div>
    
    <div v-if="showBioModal" class="modal_overlay" @click.self="showBioModal = false">
        <div class="modal_content bg_white rounded-4 p-4 shadow_box w-90" style="max-width: 400px;">
            <p class="bold font_medium mb-3 text-center">{{ t('bio_edit') }}</p>
            <textarea 
                v-model="newBio" 
                rows="5" 
                class="w-100 p-3 rounded-4 border_gray mb-3" 
                :placeholder="t('write_desc')"
            ></textarea>
            <div class="d-flex gap-2">
                <button class="button w-100" @click="submitBio" :disabled="bioLoading">
                    {{ bioLoading ? t('loading') : t('confirm') }}
                </button>
                <button class="button w-100 bg_gray" @click="showBioModal = false" :disabled="bioLoading">{{ t('cancel') }}</button>
            </div>
        </div>
    </div>

    <div v-if="showSettingsModal" class="modal_overlay" @click.self="showSettingsModal = false">
        <div class="modal_content bg_white rounded-4 p-3 shadow_box w-80" style="max-width: 300px;">
            <p class="text-center bold mb-4 text_color_theme">{{ t('post_settings') }}</p>
            
            <div class="d-flex flex-column gap-2">
                <div class="d-flex align-items-center gap-3 p-3 rounded-4 bg_gray_light cursor-pointer" @click="handleSettingAction('view')">
                    <img src="@/assets/imgs/search.svg" class="icon-size-2" alt="">
                    <span class="bold font_small">{{ t('view_post') }}</span>
                </div>

                <div class="d-flex align-items-center gap-3 p-3 rounded-4 bg_gray_light cursor-pointer" @click="handleSettingAction('edit')">
                    <img src="@/assets/imgs/edit.svg" class="icon-size-2" alt="">
                    <span class="bold font_small">{{ t('edit_post') }}</span>
                </div>

                <div class="d-flex align-items-center gap-3 p-3 rounded-4 bg_gray_light cursor-pointer" @click="handleSettingAction('delete')">
                    <img src="@/assets/imgs/close.svg" class="icon-size-2" alt="">
                    <span class="bold font_small text_color_red">{{ t('delete_post') }}</span>
                </div>
            </div>
        </div>
    </div>

    <div v-if="showEditModal" class="modal_overlay" @click.self="closeEditModal">
        <div class="modal_content bg_white rounded-4 p-3 shadow_box w-95 h-85 d-flex flex-column" style="max-width: 500px; overflow-y: auto;">
            <p class="text-center bold mb-3 text_color_theme">{{ t('edit_post') }}</p>
            
            <div class="d-flex flex-column gap-3 flex-grow-1">
                <div v-if="editForm.loadingDetails" class="d-flex justify-content-center align-items-center flex-grow-1">
                    <p>{{ t('loading') }}</p>
                </div>
                
                <template v-else>
                    <div 
                        class="w-100 bg_gray_light rounded-4 border_dashed d-flex justify-content-center align-items-center position-relative overflow-hidden cursor-pointer" 
                        style="height: 250px"
                        @click="triggerEditUpload"
                    >
                        <div v-if="editForm.isUploading" class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">...</span>
                        </div>
                        
                        <img v-else-if="editForm.preview" :src="editForm.preview" class="w-100 h-100 object-fit-contain">
                        
                        <div v-else class="d-flex flex-column align-items-center">
                            <img src="@/assets/imgs/add-post.svg" alt="" class="icon-size-4 opacity-50">
                            <p class="text_color_gray font_small mt-2">{{ t('click_to_select') }}</p>
                        </div>

                        <div v-if="editForm.preview && !editForm.isUploading" class="position-absolute top-0 start-0 p-2 z-10" @click.stop="removeEditImage">
                            <div class="bg-white rounded-circle shadow d-flex justify-content-center align-items-center" style="width: 30px; height: 30px;">
                                <img src="@/assets/imgs/close.svg" class="w-50 h-50" alt="">
                            </div>
                        </div>

                        <input type="file" ref="editFileInput" @change="onEditFileSelected" accept="image/*" style="display: none">
                    </div>

                    <textarea 
                        v-model="editForm.caption" 
                        class="w-100 p-3 rounded-4 border_gray" 
                        rows="6" 
                        :placeholder="t('write_desc')"
                    ></textarea>
                </template>
            </div>

            <div class="d-flex gap-2 mt-4" v-if="!editForm.loadingDetails">
                <button class="button w-100" @click="submitEdit" :disabled="editForm.submitting || editForm.isUploading">
                    {{ editForm.submitting ? t('loading') : t('confirm') }}
                </button>
                <button class="button w-100 bg_gray" @click="closeEditModal" :disabled="editForm.submitting">{{ t('cancel') }}</button>
            </div>
        </div>
    </div>

    <div v-if="showDeleteModal" class="modal_overlay" @click.self="showDeleteModal = false">
        <div class="modal_content bg_white rounded-4 p-4 shadow_box w-90 text-center" style="max-width: 350px;">
            <p class="bold font_medium mb-4">{{ t('delete_post_confirm') }}</p>
            <div class="d-flex gap-3">
                <button class="button w-100 bg_red" @click="confirmDelete" :disabled="deleteLoading">
                    {{ deleteLoading ? '...' : t('yes') }}
                </button>
                <button class="button w-100 bg_gray" @click="showDeleteModal = false" :disabled="deleteLoading">{{ t('no') }}</button>
            </div>
        </div>
    </div>

    <TeacherBottomNav />
  </main>
</template>

<script>
import apiClient, { createFormData } from '@/services/api'
import TeacherBottomNav from '@/components/TeacherBottomNav.vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import 'swiper/css/pagination'
import { Pagination } from 'swiper/modules'

export default {
  name: 'TeacherMyProfile',
  components: {
    TeacherBottomNav,
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      teacher: {},
      loading: false,
      showBioModal: false,
      newBio: '',
      bioLoading: false,
      isUploadingProfile: false,
      
      selectedPost: null,
      showSettingsModal: false,

      showEditModal: false,
      editForm: {
        loadingDetails: false,
        caption: '',
        preview: null,
        picName: '',
        isUploading: false,
        submitting: false,
        imageDeleted: false
      },

      showDeleteModal: false,
      deleteLoading: false
    }
  },
  setup() {
    return {
      modules: [Pagination],
    }
  },
  computed: {
    galleryImages() {
        const images = [];
        if (this.teacher.profile_pic) {
            images.push(this.teacher.profile_pic);
        } else {
            images.push(require('@/assets/imgs/NoPath - Copy (5).png'));
        }
        return images;
    }
  },
  mounted() {
    this.fetchProfile();
  },
  methods: {
    async fetchProfile() {
        this.loading = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId
            });

            const response = await apiClient.post('/teacher/profile_details', formData);

            if (response.data.status === 'ok' && response.data.data) {
                this.teacher = response.data.data;
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.loading = false;
        }
    },
    openBioModal() {
        this.newBio = this.teacher.bio || '';
        this.showBioModal = true;
    },
    async submitBio() {
        this.bioLoading = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId,
                bio: this.newBio
            });

            const response = await apiClient.post('/teacher/edit_profile_bio', formData);

            if (response.data.status === 'ok') {
                this.teacher.bio = this.newBio;
                this.showBioModal = false;
                this.notify(response.data.message || this.t('successful_submit'), 'success');
            } else {
                this.notify(response.data.message || this.t('error_submit'), 'error');
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
        } finally {
            this.bioLoading = false;
        }
    },
    triggerProfilePicUpload() {
        if (!this.isUploadingProfile) {
            this.$refs.profilePicInput.click();
        }
    },
    async handleProfilePicSelect(event) {
        const file = event.target.files[0];
        if (file) {
            this.isUploadingProfile = true;

            const formData = new FormData();
            formData.append('pic', file);
            formData.append('apikey', '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b');

            try {
                const upRes = await apiClient.post('/upload_pic', formData);
                if (upRes.data.status === 'ok') {
                    const picName = upRes.data.pic_name;
                    await this.updateTeacherProfilePic(picName);
                } else {
                    this.notify(this.t('upload_error'), 'error');
                }
            } catch (e) {
                console.error(e);
                this.notify(this.t('connection_error'), 'error');
            } finally {
                this.isUploadingProfile = false;
                event.target.value = '';
            }
        }
    },
    async updateTeacherProfilePic(picName) {
        const userId = localStorage.getItem('user_id');
        const formData = createFormData({
            teacher_id: userId,
            pic: picName
        });

        try {
            const res = await apiClient.post('/teacher/edit_profile_pic', formData);
            if (res.data.status === 'ok') {
                this.notify(this.t('successful_submit'), 'success');
                this.fetchProfile();
            } else {
                this.notify(res.data.message || this.t('error_submit'), 'error');
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
        }
    },
    goToPostDetail(postId) {
        this.$router.push({ name: 'TeacherPostDetail', query: { id: postId } });
    },
    openPostSettings(post) {
        this.selectedPost = post;
        this.showSettingsModal = true;
    },
    handleSettingAction(action) {
        this.showSettingsModal = false;
        if (!this.selectedPost) return;

        if (action === 'view') {
            this.goToPostDetail(this.selectedPost.id);
        } else if (action === 'edit') {
            this.fetchAndOpenEdit();
        } else if (action === 'delete') {
            this.showDeleteModal = true;
        }
    },
    async fetchAndOpenEdit() {
        this.showEditModal = true;
        this.editForm.loadingDetails = true;
        this.editForm.caption = '';
        this.editForm.preview = null;
        this.editForm.picName = '';
        this.editForm.imageDeleted = false;
        this.editForm.isUploading = false;
        this.editForm.submitting = false;

        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId,
                post_id: this.selectedPost.id
            });

            const response = await apiClient.post('/teacher/show_details_post', formData);
            
            if (response.data.status === 'ok' && response.data.data) {
                const postData = response.data.data;
                this.editForm.caption = postData.caption;
                this.editForm.preview = postData.pic;
                
                if (postData.pic) {
                    const parts = postData.pic.split('/');
                    this.editForm.picName = parts[parts.length - 1];
                }
            } else {
                this.notify(this.t('post_info_not_found'), 'error');
                this.showEditModal = false;
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
            this.showEditModal = false;
        } finally {
            this.editForm.loadingDetails = false;
        }
    },
    closeEditModal() {
        this.showEditModal = false;
        this.editForm.preview = null;
        this.editForm.picName = '';
    },
    removeEditImage() {
        this.editForm.preview = null;
        this.editForm.picName = '';
        this.editForm.imageDeleted = true;
    },
    triggerEditUpload() {
        if (!this.editForm.isUploading && !this.editForm.preview) {
            this.$refs.editFileInput.click();
        }
    },
    async onEditFileSelected(event) {
        const file = event.target.files[0];
        if (file) {
            this.editForm.isUploading = true;
            
            const reader = new FileReader();
            reader.onload = e => { this.editForm.preview = e.target.result; };
            reader.readAsDataURL(file);

            const formData = new FormData();
            formData.append('pic', file);
            formData.append('apikey', '4f3d2a9b7c1e5d6f8a0b9c3d2e4f6a7b');

            try {
                const res = await apiClient.post('/upload_pic', formData);
                if (res.data.status === 'ok') {
                    this.editForm.picName = res.data.pic_name;
                    this.editForm.imageDeleted = false; 
                } else {
                    this.notify(this.t('upload_error'), 'error');
                    this.editForm.preview = null;
                }
            } catch (e) {
                console.error(e);
                this.notify(this.t('upload_error'), 'error');
                this.editForm.preview = null;
            } finally {
                this.editForm.isUploading = false;
            }
        }
    },
    async submitEdit() {
        if (!this.editForm.preview && !this.editForm.picName) {
             this.notify(this.t('upload_mandatory'), 'error');
             return;
        }
        if (!this.editForm.caption.trim()) {
            this.notify(this.t('write_desc'), 'error');
            return;
        }

        this.editForm.submitting = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId,
                post_id: this.selectedPost.id,
                caption: this.editForm.caption
            });
            
            if (this.editForm.picName) {
                formData.append('pic', this.editForm.picName);
            }

            const response = await apiClient.post('/teacher/edit_post', formData);

            if (response.data.status === 'ok') {
                this.notify(response.data.message || this.t('successful_submit'), 'success');
                this.closeEditModal();
                this.fetchProfile(); 
            } else {
                this.notify(response.data.message || this.t('error_submit'), 'error');
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
        } finally {
            this.editForm.submitting = false;
        }
    },
    async confirmDelete() {
        this.deleteLoading = true;
        try {
            const userId = localStorage.getItem('user_id');
            const formData = createFormData({
                teacher_id: userId,
                post_id: this.selectedPost.id
            });

            const response = await apiClient.post('/teacher/delete_post', formData);

            if (response.data.status === 'ok') {
                this.notify(response.data.message || this.t('successful_submit'), 'success');
                this.teacher.teacher_posts = this.teacher.teacher_posts.filter(p => p.id !== this.selectedPost.id);
                this.showDeleteModal = false;
            } else {
                this.notify(response.data.message || this.t('error_submit'), 'error');
            }
        } catch (error) {
            console.error(error);
            this.notify(this.t('connection_error'), 'error');
        } finally {
            this.deleteLoading = false;
        }
    }
  }
}
</script>

<style scoped>
.profile-slider {
    border: 3px solid white;
    width: 13rem;
    height: 13rem;
    background-color: #eee;
}

.profile-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.edit-profile-icon {
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 2.5rem;
    height: 2.5rem;
    background: url('~@/assets/imgs/edit-blue-border.svg') no-repeat center;
    background-size: contain;
    z-index: 10;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
}

.spinner-sm {
    width: 1.5rem;
    height: 1.5rem;
    border-width: 2px;
}

.share-btn {
    width: 2rem;
    height: 2rem;
    margin-left: 1rem;
    cursor: pointer;
}

.edit-bio-btn {
    width: 1.5rem;
    height: 1.5rem;
}

.item-post {
    width: 32%; 
    min-width: 100px;
}

.object-fit-cover {
    object-fit: cover;
}

.object-fit-contain {
    object-fit: contain;
}

.bg_gray_light {
    background-color: #f5f5f5;
}

.cursor-pointer {
    cursor: pointer;
}

.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(5px);
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.border_gray {
    border: 1px solid #ddd;
}
.bg_gray {
    background: #a0a0a0 !important;
    box-shadow: none !important;
}
.bg_red {
    background: #FF0000 !important;
    box-shadow: 0 5px 15px rgba(255, 0, 0, 0.2) !important;
}
.filter-white {
    filter: brightness(0) invert(1);
}
.font_tiny {
    font-size: 0.7rem;
}
.text_color_red {
    color: #FF0000;
}
.border_dashed {
    border: 2px dashed #ccc;
}
.z-10 {
    z-index: 10;
}
.opacity-50 {
    opacity: 0.5;
}
.h-85 {
    height: 85vh;
}
.btn-manage-post {
    background-color: #4A90E2; 
    color: white;
    border: none;
    padding: 5px 15px;
    border-radius: 15px;
    font-size: 0.8rem;
    font-weight: bold;
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.modal_content {
  background-color: white;
  width: 85%;
  max-width: 25rem;
  border-radius: 1.5rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 30px rgba(0,0,0,0.2);
  animation: fadeIn 0.3s ease-out;
}
@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.9); }
  to { opacity: 1; transform: scale(1); }
}
</style>